import React from 'react';

interface RunOnReloadProps {
  listener: (this: Window, ev: BeforeUnloadEvent) => any;
}

export const useRunOnReload = ({ listener }: RunOnReloadProps) => {
  const memoizedAction = React.useCallback(listener, [listener]);

  React.useEffect(() => {
    window.addEventListener('beforeunload', memoizedAction);
    return () => {
      window.removeEventListener('beforeunload', memoizedAction);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
